import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
import _includesInstanceProperty from "@babel/runtime-corejs3/core-js/instance/includes";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js/instance/map";
import _reduceInstanceProperty from "@babel/runtime-corejs3/core-js/instance/reduce";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import MaterialInput from "@Shared/components/inputs/material-input.vue";
import SelectInput from "@Shared/components/inputs/select-input.vue";
import { PROVINCE_SELECT_OPTIONS } from "@Shared/utils/constants";
import { cloneDeep, pickBy } from "lodash";
import { constructLine1, generateAddressLine1 } from "@Shared/@Utils/utils";
import AutocompleteInput from "@Shared/components/inputs/autocomplete-input.vue";
import AddressLayout from "@Shared/components/layouts/general/address-layout.vue";
import { v4 as uuidv4 } from "uuid";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "AddressSection",
  components: {
    MaterialInput,
    SelectInput,
    AutocompleteInput,
    AddressLayout
  },
  props: {
    address: {
      type: [Object, Array],
      default: () => ({})
    },
    disabled: {
      type: Boolean,
      default: false
    },
    tabindex: {
      type: [String, Number],
      default: "0"
    },
    time: {
      type: Boolean,
      default: false
    },
    containerClass: {
      type: String,
      default: ""
    },
    customExpressions: {
      type: Object,
      default: () => ({})
    },
    unifyLine1: {
      type: Boolean,
      default: false
    },
    validatorContext: {
      type: Object,
      default: null
    },
    ignoredFields: {
      type: Array,
      default: () => [],
      validator: fields => fields.every(field => {
        var _context;
        return _includesInstanceProperty(_context = ["autocomplete", "line1", "street-number", "street-name", "unit-number", "street-direction", "line2", "street-type", "city", "province", "postal-code"]).call(_context, field);
      })
    }
  },
  data() {
    return {
      localAddress: cloneDeep(this.address),
      uniqueId: uuidv4()
    };
  },
  computed: {
    $v() {
      return this.$parent.$v || this.validatorContext;
    },
    handleRenderLine1() {
      this.renderLine1();
      return generateAddressLine1(this.localAddress);
    },
    lookupClass() {
      const classes = "fe-address-autocomplete address-lookup form-control";
      return `${classes} ${_mapInstanceProperty(this) ? "fe-map-address" : ""}`;
    },
    maxLengthValidationsToUse() {
      const defaultMaxLengthValidations = {
        line1: 35,
        line2: 35,
        unitNumber: 10,
        streetNumber: 10,
        streetName: 30,
        city: 20,
        postalCode: 20
      };
      return this.maxLength ? _objectSpread(_objectSpread({}, this.maxLengthValidations), defaultMaxLengthValidations) : {};
    },
    provinceOptions() {
      return PROVINCE_SELECT_OPTIONS();
    },
    ignoredFieldsFromRender() {
      var _context2;
      return _reduceInstanceProperty(_context2 = this.ignoredFields).call(_context2, (acc, field) => {
        acc[field] = true;
        return acc;
      }, {});
    }
  },
  watch: {
    localAddress: {
      //Watch for address change to reconstruct address line1
      handler(val, oldVal) {
        const transformedAddress = constructLine1(val, oldVal);
        if (transformedAddress) {
          this.$nextTick(() => {
            this.handleAddressAutocompleteChange(transformedAddress);
          });
        }
      },
      deep: true
    }
  },
  async mounted() {
    await this.$nextTick();
    this.renderLine1();
  },
  methods: {
    getValidAddressObject(address) {
      return pickBy(address, (val, key) => {
        var _context3;
        return !_includesInstanceProperty(_context3 = ["lookup", "formatted-address"]).call(_context3, key);
      });
    },
    handleChange(value, field) {
      this.localAddress = _objectSpread(_objectSpread({}, this.localAddress), {}, {
        [field]: value
      });
      this.$emit("change", this.getValidAddressObject(this.localAddress));
    },
    renderLine1() {
      this.$set(this.address, "line1", generateAddressLine1(this.localAddress));
    },
    handleAddressAutocompleteChange(addressObject) {
      this.$set(this, "localAddress", addressObject);
      this.$emit("change", this.getValidAddressObject(this.localAddress));
    }
  }
});